import { useDispatch, useSelector } from "react-redux";
import { toggleActividadAplicacionPlantelActiveThunk } from "../../../store/reducers/seleccionAplicacion/actividades-aplicacion-plantel/ActividadesAplicacionPlantel.thunks";
import Modal from "../../UI/Modal";
import Loader from "../../UI/Loader";
import { closeConfirmToggle } from "../../../store/reducers/seleccionAplicacion/actividades-aplicacion-plantel/ActividadesAplicacionPlantel.reducer";

const ConfirmToggleActividadAplicacionPlantel = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleActividadId, toggling } = useSelector(
    (state) => state.actividadesAplicacionPlantel,
  );
  const actividad = useSelector((state) =>
    state.actividadesAplicacionPlantel.list.find(
      (a) => a.id === toggleActividadId,
    ),
  );

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando actividad..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{actividad?.is_active ? "desactivar" : "activar"}</strong>{" "}
            la actividad{" "}
            <strong>"{actividad?.nombre || actividad?.actividad}"</strong>?
          </p>
          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>
            <button
              className="btn btn-primary"
              onClick={() =>
                dispatch(
                  toggleActividadAplicacionPlantelActiveThunk(
                    toggleActividadId,
                  ),
                )
              }
            >
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleActividadAplicacionPlantel;
